import Interweave from "interweave"
import React from "react"

import { ContentSeparator } from "../Utils/ContentSeparator"
import withTranslations from "./withTranslations"

const ContentBulletsView: React.FC<{ text: string }> = ({ text }) => {
  const bullets = JSON.parse(text)
  return (
    <div className="text-base sm:text-md">
      <ul className="list-disc list-inside">
        {bullets.map((item: string, index: number) => (
          <li key={index} className="flex items-start list-none">
            <p className="pr-2" style={{ paddingTop: "2px" }}>
              <span
                className="block bg-site-blue-dark rounded-full mt-2"
                style={{ width: "6px", height: "6px" }}
              />
            </p>
            <p className="inline-block flex-1">
              <Interweave key={`${index}-inter`} content={item} />
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}

const ContentBullets: React.FC<{
  content: {
    default: string[]
    translations: {
      language: string
      content: string[]
    }[]
  }
  defaultLanguage: string | undefined
}> = ({ content, defaultLanguage }) => {
  if (!content) return null
  let _translations = [] as any
  if (content.translations) {
    _translations = content.translations!.map(item => {
      return {
        language: item.language,
        content: JSON.stringify(item.content),
      }
    })
  }
  const BulletsWithTranslations = withTranslations(
    JSON.stringify(content.default),
    _translations,
    defaultLanguage,
    ContentBulletsView
  )
  return (
    <>
      <BulletsWithTranslations />
      <ContentSeparator />
    </>
  )
}

export default ContentBullets
